import { AppConstants } from "@/common";
import type { PublisherAppConfig } from "@/common/types/app-config";
const { shelfKeys }: typeof AppConstants = AppConstants;

const config: PublisherAppConfig = {
    featureHeaderEnabled: true,
    featureSplashLogoEnabled: true,
    featureLoginLogoEnabled: true,
    sessianIDTest: '5e0d5a256798a3a7b01c32a27790e066',
    userNameIDTest: '192000245464',
    authMethod: {
        featureMacAddressLoginEnabled: false,
        featureRefreshTokenLoginEnabled: false
    },
    isEnabledServiceLinkHeader: false,
    isTimeFormat12: false,
    linkItems: {
        main: {
            client: ["home","settings"],
            guest: ["home","settings"]
        },
        settings: {
            client: [
                "language",
                "clearCache"
            ],
            guest: ["language", "clearCache"]
        }
    },
    devMode: {
        sections: ["api", "oktaApi"]
    },
    mainPage: "home",
    lineViewRows: {
        home: [
            shelfKeys.trendsCards,
            shelfKeys.recentChannelsCards,
            shelfKeys.olympicsCards,
            shelfKeys.continueWatchingCards,
            shelfKeys.recentlyOnDemandCards,
            shelfKeys.liveSeries,
            shelfKeys.moviesCards,
            shelfKeys.sportsCards,
            shelfKeys.newsCards,
            shelfKeys.kidsCards,
            shelfKeys.watchAgainCards
        ],
        vod: [
            shelfKeys.channelCards,
            shelfKeys.filtersCards,
            shelfKeys.newReleasesCards,
            shelfKeys.mostPopularCards,
            shelfKeys.recommendedShowsCards,
            shelfKeys.recommendedMoviesCards,
            shelfKeys.vodContinueWatchingCards,
            shelfKeys.genresCards,
            shelfKeys.vodWatchAgainCards
        ]
    },
    guideConfig: {
        featureChannelLogoOriginalEnabled: false,
        featureRedirectToGuidefromPlayerEnabled: false,
        isDynamicOpacityChannelLogo: true,
        featureBtnWatchEnabled: false,
        featureGuideRestartBtnsEnabled: false,
        featureGuideFilterEnabled: true,
        featureGuideDetailPageEnabled: true,
        featureMoveLeftRightEnabled: true,
        featureStartFocusCanvasEnabled: false,
        featurePrevProgramEnabled: true,
        featureScrollbarEnabled: false,
        channelsPageSize: 6,
        featureUpdateViewportChannelsEnabled: true
    },
    playerConfig: {
        topPanel: {
            isEnabledChannelNumber: true,
            isEnabledChannelImage: true,
            isEnabledCallSign: true,
            isEnabledProgramName: true
        },
        controlsPanel: {
            isEnabledProgramName: false,
            isEnableAutoCloseInfoAfterUpdateProgram: true
        }
    },
    orderBy: {
        getVodInternalContent: "added_at desc"
    },
    login: {
        welcomeScreenEnabled: true
    },
};

export default defineAppConfig({...config})
